import {IColumnItem} from "@ui/tableCustom/types/columns";
import {IDeviceActivityTransform} from "@containers/device/containers/deviceActivity/types";
import {
    BASE_EXCEL_STYLES_ALIGNMENT,
    BASE_EXCEL_STYLES_BORDERS,
    BASE_EXCEL_STYLES_FILL,
    BASE_EXCEL_STYLES_FONT,
    BASE_EXPORT_HEADER_STYLES,
    BASE_EXPORT_STYLES
} from "@containers/export/constants/baseExportStyles";

export const FULL_COLUMNS: IColumnItem<IDeviceActivityTransform>[] = [
    {
        title: 'base.objectName',
        id: 'displayName',
        exportStyles: {
            ...BASE_EXPORT_STYLES,
            pdf:{
            }
        },
        exportStylesHeader: {
            excel: {
                border: BASE_EXCEL_STYLES_BORDERS,
                alignment: BASE_EXCEL_STYLES_ALIGNMENT,
                font: BASE_EXCEL_STYLES_FONT,
                fill: BASE_EXCEL_STYLES_FILL,
                rowHeight: 40
            },
        },
    },
    {
        title: 'base.groups',
        id: 'groupNames',
        exportStyles: {
            ...BASE_EXPORT_STYLES,
            pdf:{

            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },
    {
        title: 'base.lastEventTime',
        id: 'lastEventTimeTimestamp',
        exportStyles: {
            ...BASE_EXPORT_STYLES,
            pdf:{

            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },
    {
        title: 'base.status',
        id: 'status',
        exportStyles: {
            ...BASE_EXPORT_STYLES,
            pdf:{

            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },
    {
        title: 'base.appVersion',
        id: 'appVersion',
        exportStyles: {
            ...BASE_EXPORT_STYLES,
            pdf:{

            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },

]